





































import Vue from "vue";
import Spinner from "./Spinner.vue";
export default Vue.extend({
  components: { Spinner },
  props: ["value", "disable", "is_loading", "first_animate"],
});
